import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Chat/JsonRenderComponents/signalCards/AssetMacdMiniChartCard";
/**
 * ④ MACD 子图卡。 Figma：94103:23289
 */

import { useMemo } from "react";
import {
  deriveMacdChartSeries,
  formatMacdDisplay,
  MiniMacdChart,
} from "./miniCharts/MiniMacdChart";
import { SignalCardShell } from "./SignalCardShell";
import type { OhlcCandlePoint, SignalCardAssetProps } from "./types";

const I18n = I18nUtil.createScoped(Translations);

export interface AssetMacdMiniChartCardProps extends SignalCardAssetProps {
  candles: OhlcCandlePoint[];
}

export const AssetMacdMiniChartCard: React.FC<AssetMacdMiniChartCardProps> = ({
  candles,
  ...asset
}) => {
  const { lastDif, lastDea, lastMacd } = useMemo(
    () => deriveMacdChartSeries(candles),
    [candles],
  );

  return (
    <SignalCardShell {...asset}>
      <div className="flex flex-col gap-2">
        <p className="body_medium_s text-content_quaternary">
          {I18n.t("MACD(12, 26, 9)")}
        </p>
        <div className="flex flex-wrap gap-1 body_medium_s">
          <span className="text-content_brand_primary">
            {I18n.t("DIF:")}
            {formatMacdDisplay(lastDif)}
          </span>
          <span className="text-content_accent4_primary">
            {I18n.t("DEA:")}
            {formatMacdDisplay(lastDea)}
          </span>
          <span className="text-content_accent1_primary">
            {I18n.t("MACD:")}
            {formatMacdDisplay(lastMacd)}
          </span>
        </div>
        <MiniMacdChart candles={candles} />
      </div>
    </SignalCardShell>
  );
};
